export default __webpack_public_path__ + "static/media/net-dropdown.557e217a.webp";